(function () {
  var lastRequestedVal = null;

  /* ── Loader ── */
  function showLoader() {
    if (document.getElementById('apex-price-loader')) return;
    var overlay = document.createElement('div');
    overlay.id = 'apex-price-loader';
    overlay.innerHTML = '<div class="apex-price-loader__spinner"></div>';
    document.body.appendChild(overlay);

    // Dawn hides .loading__spinner (adds class "hidden") at the very end of
    // renderProductCount — after both filters AND product grid are fully rendered.
    // Watching that is the only reliable signal that everything is done.
    // We delay 50ms so renderPage has had time to first SHOW the spinner.
    setTimeout(function () {
      var spinner = document.querySelector('.facets-container .loading__spinner');
      if (!spinner || spinner.classList.contains('hidden')) {
        // Render already finished (cache hit) or no spinner found
        hideLoader();
        return;
      }
      var obs = new MutationObserver(function () {
        if (spinner.classList.contains('hidden')) {
          obs.disconnect();
          hideLoader();
        }
      });
      obs.observe(spinner, { attributes: true, attributeFilter: ['class'] });
    }, 50);

    // Hard fallback — never stay open longer than 10 s
    setTimeout(hideLoader, 10000);
  }

  function hideLoader() {
    var overlay = document.getElementById('apex-price-loader');
    if (overlay) overlay.parentNode.removeChild(overlay);
  }

  /* ── Helpers ── */
  function parsePrice(str) {
    if (!str) return 0;
    return parseFloat(String(str).replace(/[^0-9.]/g, '')) || 0;
  }

  function formatNum(val) {
    return Math.round(val).toLocaleString('en-IN');
  }

  /* ── Build slider ── */
  function buildSlider(priceRangeEl) {
    if (priceRangeEl.dataset.apexSliderBuilt) return;
    priceRangeEl.dataset.apexSliderBuilt = '1';

    var inputs   = priceRangeEl.querySelectorAll('input');
    var gteInput = inputs[0];
    var lteInput = inputs[1];
    if (!gteInput || !lteInput) return;

    var gteName  = gteInput.name;
    var lteName  = lteInput.name;
    var rangeMax = parsePrice(lteInput.getAttribute('data-max') || gteInput.getAttribute('data-max'));
    if (!rangeMax) return;

    var step     = Math.max(1, Math.round(rangeMax / 500));
    var lastStep = Math.floor(rangeMax / step) * step;

    function isAtMax(val) { return val >= lastStep; }

    var serverVal = parsePrice(lteInput.value) || rangeMax;
    var currMax   = (lastRequestedVal !== null) ? lastRequestedVal : serverVal;

    var currEl = priceRangeEl.querySelector('.field-currency');
    var curr   = currEl ? currEl.textContent.trim() : '₹';

    /* Build DOM */
    var wrapper = document.createElement('div');
    wrapper.className = 'apex-price-range';

    var valRow = document.createElement('div');
    valRow.className = 'apex-price-range__values';
    valRow.innerHTML =
      '<span class="apex-price-range__currency">' + curr + '</span>' +
      '<span class="apex-price-range__min-val">0</span>' +
      '<span class="apex-price-range__sep">—</span>' +
      '<span class="apex-price-range__currency">' + curr + '</span>' +
      '<span class="apex-price-range__max-val">' + formatNum(isAtMax(currMax) ? rangeMax : currMax) + '</span>';

    var slider = document.createElement('input');
    slider.type      = 'range';
    slider.className = 'apex-price-range__input';
    slider.min       = 0;
    slider.max       = rangeMax;
    slider.step      = step;
    slider.value     = currMax;

    wrapper.appendChild(valRow);
    wrapper.appendChild(slider);

    function updateFill() {
      var pct = (slider.value / rangeMax) * 100;
      slider.style.background =
        'linear-gradient(to right, #e0001b 0%, #e0001b ' + pct +
        '%, rgba(0,0,0,0.12) ' + pct + '%, rgba(0,0,0,0.12) 100%)';
    }

    // input  → update label + fill only, NO AJAX (eliminates all race conditions)
    slider.addEventListener('input', function () {
      var val = Math.round(parseFloat(slider.value));
      valRow.querySelector('.apex-price-range__max-val').textContent =
        formatNum(isAtMax(val) ? rangeMax : val);
      updateFill();
    });

    // change → fires once on mouse/touch release → single AJAX, always correct
    slider.addEventListener('change', function () {
      var val = Math.round(parseFloat(slider.value));
      valRow.querySelector('.apex-price-range__max-val').textContent =
        formatNum(isAtMax(val) ? rangeMax : val);
      updateFill();
      lastRequestedVal = val;
      showLoader();
      applyFilter(val);
    });

    function applyFilter(val) {
      var urlParams = new URLSearchParams(window.location.search);
      urlParams.delete(gteName);
      urlParams.delete(lteName);

      if (!isAtMax(val)) {
        urlParams.set(lteName, String(val));
      }

      var sortForm = document.getElementById('FacetSortForm');
      if (sortForm) {
        new URLSearchParams(new FormData(sortForm)).forEach(function (v, k) {
          if (v) urlParams.set(k, v);
        });
      }

      var filterForm = document.getElementById('FacetFiltersForm');
      if (filterForm) {
        new URLSearchParams(new FormData(filterForm)).forEach(function (v, k) {
          if (k !== gteName && k !== lteName && v) urlParams.set(k, v);
        });
      }

      if (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.renderPage) {
        // Clear Dawn's cache so a stale cached response never renders over the
        // current request (was causing "keeps showing old products" bug).
        if (Array.isArray(FacetFiltersForm.filterData)) FacetFiltersForm.filterData = [];
        FacetFiltersForm.renderPage(urlParams.toString(), null, true);
      }
    }

    priceRangeEl.classList.add('apex-price-hidden');
    priceRangeEl.parentNode.insertBefore(wrapper, priceRangeEl);
    updateFill();
  }

  function init() {
    document.querySelectorAll('price-range.facets__price').forEach(buildSlider);
  }

  var observer = new MutationObserver(function () { setTimeout(init, 0); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      observer.observe(document.body, { childList: true, subtree: true });
    });
  } else {
    init();
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
